/**
 * Load boards may return several broker contacts in one field. Normalize that wire
 * format before composing a request so each contact remains a distinct recipient.
 */
export const splitRecipientEmails = (value: string): string[] =>
    Array.from(
        new Map(
            value
                .split(/[,;]\s*/)
                .map((email) => email.trim())
                .filter(Boolean)
                .map((email) => [email.toLowerCase(), email])
        ).values()
    )

export const mergeCcRecipients = (toRecipients: string[], ...recipientLists: string[][]): string[] => {
    const toRecipientSet = new Set(toRecipients.map((email) => email.toLowerCase()))
    return Array.from(
        new Map(
            recipientLists
                .flat()
                .filter((email) => !toRecipientSet.has(email.toLowerCase()))
                .map((email) => [email.toLowerCase(), email])
        ).values()
    )
}
